import { InfoOutlined } from '@mui/icons-material';
import { type AlertProps, Alert as MUIAlert, type Theme } from '@mui/material';

// Define custom severity types
type CustomSeverity = 'surface' | 'surfaceVariant' | 'blue' | 'danger';

interface CustomAlertProps extends AlertProps {
    severity: CustomSeverity;
    children?: React.ReactNode;
}

// Define colors for the new severities
const severityStyles: Record<
    CustomSeverity,
    { color: ((t: Theme) => string) | string; backgroundColor: ((t: Theme) => string) | string }
> = {
    surface: { color: (t: Theme) => t.palette.primary.main, backgroundColor: '#FFF' },
    surfaceVariant: { color: (t: Theme) => t.palette.primary.main, backgroundColor: '#F5F5F5' },
    blue: { color: (t: Theme) => t.palette.primary.onSurface, backgroundColor: '#E7F8FF' },
    danger: { color: '#974401', backgroundColor: '#FFE4CD' },
};

const Alert = ({ severity, sx, ...props }: CustomAlertProps) => {
    const { color, backgroundColor } = severityStyles[severity || 'surface'];

    return (
        <MUIAlert
            {...props}
            iconMapping={{
                success: <InfoOutlined sx={{ fontSize: 22 }} />, // Because the custom severities doesn't overlap with the MUI ones, in the backgroud all Alerts are using 'success'
            }}
            sx={{
                color,
                backgroundColor,
                alignItems: 'center',
                fontSize: (theme) => theme.typography.body2.fontSize,
                '.MuiAlert-icon': { color },
                '.MuiAlert-message': { py: 0 },
                borderRadius: 0,
                py: 1,
                ...sx, // Allow additional styles from props
            }}
        />
    );
};

export default Alert;
